import { setCookie } from "@rokid/utils";
import { rokidAccountBaseUrl } from "@rokid/host";

// rokid账号退出登录
export const logoutOfRokid = () => {
  // 清除rokid账号cookie
  setCookie("ROKID_ACCOUNT_SESSION", "", -1, "rokid.com");
};

// rokid 跳转至账号中心
export const redirectToRokidAccountCenter = (redirectPath?: string) => {
  // 如果没有重定向路径，跳转账号中心
  if (!redirectPath) {
    window.location.href = rokidAccountBaseUrl;
  }
  // 否则跳转登录页
  else {
    window.location.href =
      window.location.href = `${rokidAccountBaseUrl}/login?redirect=${encodeURIComponent(
        redirectPath
      )}`;
  }
};

// rokid 跳转至开发者认证页
export const redirectToRokidDeveloperVerify = () => {
  window.location.href = `${rokidAccountBaseUrl}/verify`;
};

export const handleDeveloperVerify = (msg: string): {subTitleKey:string,guideUrl:string} => { 
    let subTitleKey = 'workspace_no_verify';
    let guideUrl = '';
    /*此处的msg有三种情况
      not_developer_check - 完成实名认证未完成开发者认证
      developer_checking - 开发者认证待审核
      not_idcard_check - 未完成实名认证
    */
    if (msg === 'developer_checking') {
      subTitleKey = 'workspace_wait_verify';
    } else {
      guideUrl = `${rokidAccountBaseUrl}/verify?needLevel=2&redirect=${encodeURIComponent(location.href)}`;
    }
  return {subTitleKey,guideUrl}
}